module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-144x144-deff2ff610d18d04c9027448f131abac.png";